
import { FirearmAssignmentLogEntityDecoratorBase } from './firearm-assignment-log.decorator.base';


export class FirearmAssignmentLogEntityDecorator extends FirearmAssignmentLogEntityDecoratorBase {
  constructor() {
    super();
  }
}



